import starIcon from '@/resources/star.svg';
import starFilledIcon from '@/resources/star_filled.svg';
import React from 'react';
import { translate } from '@/services/TranslationService';

const NovovilleRating = ({ rating, onChange, disabled = false }) => {
  const [hoveredIndex, setHoveredIndex] = React.useState(null);

  const handleRatingChange = (newRating) => {
    if (!disabled) {
      onChange(newRating);
    }
  };

  return (
    <div className="flex flex-col max-w-60 items-center justify-between space-y-1">
      <div className="group flex w-full items-center justify-between space-x-2">
        {Array.from({ length: 5 }, (_, index) => {
          const starIndex = index + 1;
          const isFilled = starIndex <= rating;
          const starIconSrc = isFilled ? starFilledIcon : starIcon;

          return (
            <div key={index} className="flex-1 flex justify-center">
              <img
                src={starIconSrc}
                alt={`Star ${starIndex}`}
                className={`flex-1 cursor-pointer transition-all duration-300 ease-in-out transform ${
                  index <= hoveredIndex && !disabled ? 'scale-110' : ''
                } ${disabled ? 'opacity-50' : 'hover:opacity-75'}`}
                onClick={() => handleRatingChange(starIndex)}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              />
            </div>
          );
        })}
      </div>
      <div className="flex justify-between w-full px-1 text-sm text-gray-700 relative h-5">
        <span className="w-6 text-center absolute top-0 left-0">
          {translate('Bad')}
        </span>
        <span className="w-6 text-center absolute top-0 right-0 -translate-x-full">
          {translate('Excellent')}
        </span>
      </div>
    </div>
  );
};

export default React.memo(NovovilleRating);
